import { SvgTypeset, Y_EM, TOP_PAD } from '@lovepop/svg-writer';
import { emulateWordBreakAt } from './text-utils';
import { SVG_HEIGHT, PADDING } from './constants';

const breakWordsAt20 = emulateWordBreakAt(20);

/*
 * WARNING
 * this ended up being a bit complicated to implement
 * and changes can easily cause infinite loops.
 * for now, this complexity is worth it since it
 * lets us debounce the typesetting which can
 * be quite expensive.
 */
const asyncWriteReducer = async (acc, text) => {
  acc = await acc;
  const startAt = acc.prevLastEl
    ? parseFloat(acc.prevLastEl.getAttribute('y').slice(0, -2)) + Y_EM
    : TOP_PAD;

  acc.textEl = await SvgTypeset(
    text,
    acc.textEl,
    acc.textContainer,
    acc.format,
    acc.lineLengths,
    acc.tolerance,
    acc.center,
    acc.spaceChar,
    startAt,
    acc.withHyphenation
  );

  acc.prevLastEl = acc.textEl.lastChild;
  return Promise.resolve(acc);
};

export const asyncWrite = async (args) => {
  const paragraphs = breakWordsAt20(args.text).split('\n');
  const te = document.createElementNS('http://www.w3.org/2000/svg', 'text');

  /*
   * WARNING: this needs to be a grayscal value. we are keying
   * off of this when sending to the printer to determine if
   * a note is black and white or color. each rgb value needs to
   * be equal. so #ffffff is valid but #ffbbaa is not.
   */
  te.setAttribute('fill', args.fontColor);
  te.setAttribute('font-family', args.fontFamily);
  te.setAttribute('font-size', args.fontSize);

  const opts = {
    ...args,
    textEl: te,
    prevLastEl: null
  };

  await paragraphs.reduce(asyncWriteReducer, Promise.resolve(opts));

  /* this should probably moved out of this function */
  const gCenter = args.textContainer.getBBox().height / 2;
  const svgCenter = SVG_HEIGHT / 2;
  const offset = (svgCenter - gCenter) - (Y_EM * args.fontSize) - PADDING;

  return { offset, textContainer: args.textContainer };
}
